import classnames from 'classnames'
import * as React from 'react'

import { StyleBreakpoints } from '@/lib/StyleVariables.ts'
import { useWindowSize } from '@/lib/useWindowSize.ts'

import styles from './NordicButton.module.scss'

interface MyProps {
	centered?: boolean
	className?: string[] | string
	disabled?: boolean
	id?: string
	marginBottom?: boolean
	marginLeft?: boolean
	marginRight?: boolean
	marginTop?: boolean
	onClick?: React.MouseEventHandler<HTMLButtonElement>
	showSlant?: boolean
	size?: 'small' | 'large'
	type?: 'button' | 'submit' | 'reset'
	mobileIcon?:
		| 'delete_forever'
		| 'refresh'
		| 'edit'
		| 'drive_file_rename_outline'
		| 'add_photo_alternate'
		| string
	variant?: string
}

export type NordicButtonProps = MyProps &
	React.HTMLAttributes<HTMLButtonElement>

const NordicButton: React.FC<NordicButtonProps> = ({
	children,
	centered,
	className,
	id,
	size,
	onClick,
	disabled,
	marginBottom,
	marginLeft,
	marginRight,
	marginTop,
	showSlant,
	type,
	variant = 'primary',
	mobileIcon,
	...props
}) => {
	const { width } = useWindowSize()

	const isSiteIcon = mobileIcon?.includes('site-icon')

	const handleOnClick = React.useCallback(
		(e) => {
			e?.preventDefault?.()
			if (onClick) {
				onClick(e)
			}
		},
		[onClick],
	)

	return (
		<button
			onClick={handleOnClick}
			disabled={disabled}
			id={id}
			type={type}
			className={classnames(
				styles.button,
				styles[variant as keyof typeof styles],
				styles[size as keyof typeof styles],
				centered && styles.centered,
				marginBottom && styles.marginBottom,
				marginLeft && styles.marginLeft,
				marginRight && styles.marginRight,
				marginTop && styles.marginTop,
				showSlant ? styles.slant : styles.noSlant,
				className,
			)}
			{...props}
		>
			{mobileIcon && width <= StyleBreakpoints.sm ? (
				<i
					className={
						isSiteIcon
							? `${mobileIcon} ${styles.siteIcon}`
							: 'material-icons icon-no-margin'
					}
				>
					{!isSiteIcon && mobileIcon}
				</i>
			) : (
				children
			)}
		</button>
	)
}

export default NordicButton
